import React from 'react'

import { FieldArray } from 'formik'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem4sm6xs12,
} from '../../../business-components/Grid/Grid'

import {
    PanelRadioGroup
} from '../../../business-components/RadioGroup/RadioGroup'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import tipoDiaDiaList from '../../../business-rules/List/tipoDiaDiaList'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    obtemPage,
    salvaPage,
} from '../cliente-form/ClienteService'

import {
    TablePaginationPadraoDiaDia,
    rowPertentePageDiaDia,
    setPageInclusaoDiaDia,
} from './DespesasCompDiaDia'

import {
    incrementaContDiaDia,
    processaRegistrosDefaultIniciaisDiaDia,
    processaAlteracaoDiaDiaAlterarPeriodoDiaDia,
    calculaTotaisDiaDia,
} from './DespesasServiceDiaDia'

import DespesasFormDiaDiaItem from './DespesasFormDiaDiaItem'



const DespesasFormDiaDia = ({ values, handleChange, setFieldValue, linhaTipoLicenca, jsonConfiguracao }) => {

    calculaTotaisDiaDia(values, jsonConfiguracao)

    useSingleton(async () => {

        values.pageDiaDia = obtemPage(values.pageDiaDiaList, Number.parseInt(values.familiarDiaDia))
    })

    salvaPage(values.pageDiaDia, values.pageDiaDiaList, Number.parseInt(values.familiarDiaDia))

    let indAux = 0
    
    values.diaDiaPagination = 
        values.diaDia
            ?
                values.diaDia.filter(item => item.familiar === Number.parseInt(values.familiarDiaDia))
            :
                []



    return (
        <>
            <PanelRadioGroup
                name="familiarDiaDia"
                value={Number.parseInt(values.familiarDiaDia) || ''}
                onChange={(e) => {
                    values.pageDiaDia = obtemPage(values.pageDiaDiaList, Number.parseInt(e.target.value))
                    handleChange(e)
                }}
                list={values.totalDiaDia}
                onBlur={
                    processaRegistrosDefaultIniciaisDiaDia(values,
                        Number.parseInt(values.familiarDiaDia))
                }
                helpText={HELPTEXT.diaDiaPanelRadioGroup}
            />
               
            <FieldArray name="diaDia">
                {(arrayHelpers) => (
                    <DivForm>
                        <GridContainer>
                            {values.diaDia?.map((item, ind) => {

                                processaAlteracaoDiaDiaAlterarPeriodoDiaDia(item, values)

                                return item.familiar === Number.parseInt(values.familiarDiaDia) && rowPertentePageDiaDia(values, indAux++) ? (
                                    <GridItem4sm6xs12
                                        key={ind}
                                    >
                                        <DespesasFormDiaDiaItem
                                            values={values}
                                            handleChange={handleChange}
                                            setFieldValue={setFieldValue}
                                            arrayHelpers={arrayHelpers}
                                            linhaTipoLicenca={linhaTipoLicenca}
                                            jsonConfiguracao={jsonConfiguracao}
                                            tipoDiaDiaSelecionado={pesquisaList(tipoDiaDiaList, item.tipoDiaDia)}
                                            item={item}
                                            ind={ind}
                                            simplificado={false}
                                        />
                                    </GridItem4sm6xs12>
                                )
                                :
                                (
                                   ''
                                )
                            })}
                        </GridContainer>

                        <TablePaginationPadraoDiaDia
                            values={values}
                            setFieldValue={setFieldValue}
                        />

                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirDiaDia} 
                            disabled={familiaresList(values).length === 0 || !values.familiarDiaDia ? true : false}
                            onClick={() =>
                                {
                                    incrementaContDiaDia(values)
                                    arrayHelpers.push({
                                        id: values.contDiaDia,
                                        familiar: Number.parseInt(values.familiarDiaDia)
                                    })
                                    setPageInclusaoDiaDia(values, setFieldValue)
                                }
                            }
                        />
                    </DivForm>
                )}
            </FieldArray>
        </>
    )
}

export default DespesasFormDiaDia